<template>
  <div class="container" style="margin-top: 24px">
    <proton-module
    :auths="auth"
    :proton="proton"
    :key="proton"
    @recharge-succeed="rechargeSucceed"
    ></proton-module>
  </div>
</template>
<script>
import { mapGetters, mapMutations } from 'vuex'
import { ProtonModule } from 'lingdongliang-module'
export default {
  name: 'Protons',
  computed: {
    ...mapGetters([
      'proton',
      'userInfo'
    ]),
    auth () {
      if (this.userInfo) {
        return this.userInfo.auths
      }
      return []
    }
  },
  methods: {
    ...mapMutations([
      'updateProton'
    ]),
    rechargeSucceed (proton) {
      this.updateProton(proton)
    }
  },
  components: {
    'proton-module': ProtonModule
  }
}
</script>
